// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MatrixStackedBars_wrapper__Gu8gI","border":"MatrixStackedBars_border__qUwbB"};